import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../SupplierState'
import dayjs from 'dayjs'

export const useUpdateTab = () => {
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const handleApiFailure = useCallback((message) => {
    dispatch(actions.setLastUpdatedInfo({
      dateOrMessage: message,
      error: true,
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleApiSuccess = useCallback(() => {
    const timeNow = dayjs().format('HH:mm:ss')
    dispatch(actions.setLastUpdatedInfo({
      dateOrMessage: timeNow,
      error: '',
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleUpdate = useCallback(
    async (apiCall, responseHandler) => {
      setLoading(true)

      const response = await apiCall()

      setLoading(false)

      if (!response.isOk) {
        handleApiFailure(response.data.message)
        return
      }

      handleApiSuccess()
      responseHandler(response)
    },
    [handleApiFailure, handleApiSuccess],
  )

  return {
    loading,
    handleUpdate,
  }
}
